module.exports = __webpack_public_path__ + "static/media/2.48fc753e.jpg";